import NiceModal from '@ebay/nice-modal-react';

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Button from 'components/field/Button';
import Image from 'components/global/Image';
import ManageWidgetsModal from 'components/global/ManageWidgets/ManageWidgetsModal';
import { Container } from 'components/global/styled/WidgetsContainer.styled';

import { analysisChartsConfigRaw, chartsConfig } from 'pages/Analysis/analysisWidgetsConfig';
import { dashboardChartsConfigRaw } from 'pages/Dashboard/dashboardConfig';
import { monitorViewRaw } from 'pages/Dashboard/monitorView';
import { homePageChartsConfigRaw } from 'pages/Home/RecurringPage/homePageChartsConfig';

import AppLogger from 'utils/AppLogger';
import PATHS from 'utils/paths';

import { faObjectsColumn } from '@fortawesome/pro-solid-svg-icons';

import { WIDGET_VERSION } from './ManageWidgets/widgetsUtils';
import Typography from './Typography';
import * as S from './styled/WidgetsContainer.styled';

export const safeParseLocalStorage = (key) => {
	try {
		const item = localStorage.getItem(key);
		return item ? JSON.parse(item) : null;
	} catch (error) {
		AppLogger.error(`Error parsing localStorage item: ${key}`, error);
		return null;
	}
};

const WidgetPageContainer = ({ children, widgetsData }) => {
	const { pathname } = useLocation();
	const [noVisibleWidgets, setNoVisibleWidgets] = useState(
		safeParseLocalStorage(`${pathname}${WIDGET_VERSION}`)?.every((widget) => !widget.isVisible) || false
	);

	const updateWidgetVisibility = () => {
		setNoVisibleWidgets(
			safeParseLocalStorage(`${pathname}${WIDGET_VERSION}`)?.every((widget) => !widget.isVisible) || false
		);
	};

	useEffect(() => {
		window.addEventListener('updateWidgetVisibility', updateWidgetVisibility);

		return () => {
			window.removeEventListener('updateWidgetVisibility', updateWidgetVisibility);
		};
	}, []);

	let data;
	if (pathname.startsWith(PATHS.ANALYSIS)) {
		data = chartsConfig(analysisChartsConfigRaw);
	}
	if (pathname.startsWith(PATHS.DASHBOARD)) {
		data = chartsConfig(dashboardChartsConfigRaw);
	}
	if (pathname.startsWith(PATHS.HOME)) {
		data = chartsConfig(homePageChartsConfigRaw);
	}
	if (pathname.startsWith(PATHS.DASHBOARD_MONITOR_VIEW) || pathname.startsWith(PATHS.ANALYSIS_MONITOR_VIEW)) {
		data = chartsConfig(monitorViewRaw);
	}

	return noVisibleWidgets ? (
		<Container>
			<S.EmptyDataCard fullHeight fullWidth>
				<Image
					url={'https://storage.googleapis.com/tryoto-public/public/assets/icons/no-data-card.svg'}
					alt="emptyDataCards"
					height="12rem"
					width="12rem"
					className="mt-4"
				/>
				<Typography variant="p2" className="my-4 text-center" fontWeight="700" noWrap gutterBottom>
					noDataCardsTitle
				</Typography>
				<Typography variant="p3" className="text-center" color="var(--content-3)" noWrap>
					noRecordsFoundSubtitleManageWidgets
				</Typography>
				<Button
					className="my-4"
					icon={faObjectsColumn}
					label={'manageWidgets.buttonLabel'}
					variant="blue"
					onClick={() =>
						NiceModal.show(ManageWidgetsModal, {
							data: widgetsData || data
						})
					}
				/>
			</S.EmptyDataCard>
		</Container>
	) : (
		<Container>{children}</Container>
	);
};

export default WidgetPageContainer;
